import React, { useContext, useState } from "react";
import Context from "../../../../../Context";
import { Modal } from "react-bootstrap";
import Blocker from "../../../../Misc/Blocker";

function showItemValue(item) {
  let value = item.value || {};
  let displayValue = "";
  if (value.vtype === 0) displayValue = value.vinteger;
  if (value.vtype === 1) displayValue = value.vnumeric;
  if (value.vtype === 2) {
    let date = new Date(value.vdatetime);
    displayValue = `${date.toLocaleString()}`;
  }
  if (value.vtype === 3) displayValue = value.vstring;
  if (value.vtype === 4) displayValue = value.vboolean;
  return displayValue;
}

export default function EditModal(props) {
  let item = props.item || {};
  let type = item.value ? item.value.vtype : 0;

  let sPath = Array.isArray(item.path) ? item.path.join("\\") : "";
  let defaultInputValue = showItemValue(item);

  let [inputValue, changeInputValue] = useState(defaultInputValue);
  let [pending, setPending] = useState(false);

  const cx = useContext(Context);

  async function save() {
    setPending(true);
    let registryKeysGot = await cx.api.q("/registry/write", {
      key: item.keyname,
      subkey: sPath,
      name: item.valuename,
      type: type,
      data: inputValue,
    });
    if (registryKeysGot !== false) {
      cx.toast(
        `${sPath} ${item.valuename}: Значение параметра успешно сохранено `,
        "success"
      );
      props.onEdit(item, inputValue);
      hide();
    } else {
      cx.toast(
        `${sPath} ${item.valuename}: не удалось сохранить значение `,
        "error"
      );
    }
    setPending(false);
  }

  function hide() {
    changeInputValue("");
    props.onHide();
  }

  let input =
    type !== 4 ? (
      <input
        onKeyPress={(e) => {
          if (e.key === "Enter") save();
        }}
        className="form-control"
        id="data"
        value={inputValue}
        onChange={(e) => changeInputValue(e.target.value)}
        onClick={(e) => e.target.select()}
      />
    ) : (
      <select
        className="form-control"
        id="data"
        value={inputValue}
        onChange={(e) => changeInputValue(e.target.value)}
      >
        <option value="true">Да</option>
        <option value="false">Нет</option>
      </select>
    );
  return (
    <Modal onHide={hide} show={props.show}>
      <Blocker on={pending}>
        <Modal.Header closeButton>
          <div className="modal-title w-100 h4 d-flex justify-content-between">
            <span> Изменение значения </span>
            <span className="text-muted">{item.valuename}</span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <span className="text-muted mr-2">Имя значения</span>{" "}
            {item.valuename}
            <br />
            <span className="text-muted mr-2">Подключ (путь)</span> {sPath}
          </div>
          <div className="form-group">
            <label>Значение</label>
            {input}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={save}>
            Сохранить
          </button>
          <button className="btn btn-secondary" onClick={hide}>
            Отмена
          </button>
        </Modal.Footer>
      </Blocker>
    </Modal>
  );
}
